import React from "react";
import {
  useIsProductLoading,
  useActivePartKey,
  type OrderCodePart as OrderCodePartType,
} from "stores/product";
import cx from "classnames";
import { useIsPartDisabled } from "components/ProductConfigurator/hooks/useIsPartDisabled";

export const OrderCodePart = ({
  part,
  onClick,
}: {
  part: OrderCodePartType;
  onClick: () => void;
}) => {
  const activePartKey = useActivePartKey();
  const isProductLoading = useIsProductLoading();

  const isDisabled = useIsPartDisabled(part);

  return (
    <div
      data-testid={`order-code-part-${part.key}`}
      className={cx("d-flex align-items-center h-100", {
        blockSkeletonBlue: isProductLoading,
      })}
    >
      <button
        className={cx("px-2 py-1 bg-white border h-100", {
          "cursor-not-allowed ": part.state === 3 || isDisabled,
          "cursor-pointer": !(part.state === 3 || isDisabled),
          // Todo: add active part
          "border-info bg-blue-50": activePartKey === part.key,
          "opacity-0": isProductLoading,
        })}
        disabled={part.state === 1 || part.state === 3 || isDisabled}
        // Todo: add onClick to open order code options modal and set active part
        onClick={onClick}
      >
        {part.presentation || "\u00A0"}
      </button>
    </div>
  );
};
